exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vehicle[data-v-2fa12fb4] {\n  max-width: 500px;\n  max-height: 50px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/shared/home-modules/header/vms-vehicle-count.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;CACrB","file":"vms-vehicle-count.vue","sourcesContent":["\n.vehicle[data-v-2fa12fb4] {\n  max-width: 500px;\n  max-height: 50px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fa12fb4","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared/home-modules/header/vms-vehicle-count.vue
// module id = K2lm
// module chunks = 7